import {
  Activity,
  BarChart3,
  Bell,
  Bot,
  CreditCard,
  History,
  House,
  MessagesSquare,
  Plug,
  ShieldCheck,
  Store,
  UsersRound,
  type LucideIcon,
} from 'lucide-react';

/** Ícono de cada módulo: el mismo en el menú, en la cabecera de la pantalla y en las migas. */
export const MODULE_ICONS: Record<string, LucideIcon> = {
  overview: House,
  analytics: BarChart3,
  history: History,
  inbox: MessagesSquare,
  leads: Store,
  prompts: Bot,
  ops: Activity,
  alerts: Bell,
  config: Plug,
  team: UsersRound,
  subscription: CreditCard,
  superadmin: ShieldCheck,
};

export const moduleIcon = (id: string): LucideIcon => MODULE_ICONS[id] ?? House;
